import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService, NotificationService } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SidenavStudioService } from '../../services/sidenav-studio.service';
import { StudioService } from '../../services/studio.service';

@Component({
  selector: 'app-modal-duplicate-courses',
  templateUrl: './modal-duplicate-courses.component.html',
  styles: [],
  standalone: false,
})
export class ModalDuplicateCoursesComponent implements OnInit {
  public form: FormGroup;
  public collections$ = new BehaviorSubject<any>(undefined);

  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private studioService: StudioService,
    private sidenavStudioService: SidenavStudioService,
  ) {}

  public ngOnInit() {
    this.initForm();
    this.collections$.next(
      this.data.categories.flatMap((category) =>
        category.colecoes.map((collection) => ({
          name: collection.nome,
          category_name: category.nome,
          id: collection.id,
        })),
      ),
    );
    setTimeout(() => {
      this.form.controls['collection_id'].updateValueAndValidity();
    });
  }

  public onClose() {
    this.dialogRef.close();
  }

  public onSave() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loadingService.start();
    this.studioService
      .duplicateCourse(this.data.selectedCourse.id, this.form.value.collection_id)
      .pipe(finalize(() => this.loadingService.finish()))
      .subscribe({
        next: (resp) => {
          if (resp.ret) {
            this.notificationService.success(this.translateService.instant('trilhas.estudio.sucesso-duplicar'));
            this.sidenavStudioService.duplicateCourse(this.form.value.collection_id, this.data.selectedCourse, resp);
            this.dialogRef.close();
          } else {
            this.notificationService.warning(resp.msg);
          }
        },
        error: (e) => {
          this.notificationService.error(e.error.msg);
        },
      });
  }

  private initForm() {
    this.form = this.formBuilder.group({
      collection_id: [null, Validators.required],
    });
  }
}
